import type { ReactNode } from 'react';

import { StyledRadioBorder, StyledRadioContainer, StyledRadioLabelText, StyledRadioInput } from './styles';

export type RadioButtonProps = {
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  label: ReactNode;
  className?: string;
  labelFirst?: boolean;
};

export const RadioButton = ({ label, selected, disabled, onClick, className }: RadioButtonProps) => {
  return (
    <StyledRadioContainer className={className} selected={selected} disabled={disabled}>
      <StyledRadioInput type="radio" checked={selected} disabled={disabled} onChange={onClick} />
      <StyledRadioBorder />
      <StyledRadioLabelText>{label}</StyledRadioLabelText>
    </StyledRadioContainer>
  );
};
